export interface CallingCodeCountry {
  iso2: string;
  nameEn: string;
  nameEs: string;
  dialCode: string;
}

export const callingCodes: CallingCodeCountry[] = [
  { iso2: 'AD', nameEn: 'Andorra', nameEs: 'Andorra', dialCode: '376' },
  { iso2: 'AE', nameEn: 'United Arab Emirates', nameEs: 'Emiratos Árabes Unidos', dialCode: '971' },
  { iso2: 'AF', nameEn: 'Afghanistan', nameEs: 'Afganistán', dialCode: '93' },
  { iso2: 'AG', nameEn: 'Antigua and Barbuda', nameEs: 'Antigua y Barbuda', dialCode: '1' },
  { iso2: 'AI', nameEn: 'Anguilla', nameEs: 'Anguila', dialCode: '1' },
  { iso2: 'AL', nameEn: 'Albania', nameEs: 'Albania', dialCode: '355' },
  { iso2: 'AM', nameEn: 'Armenia', nameEs: 'Armenia', dialCode: '374' },
  { iso2: 'AO', nameEn: 'Angola', nameEs: 'Angola', dialCode: '244' },
  { iso2: 'AR', nameEn: 'Argentina', nameEs: 'Argentina', dialCode: '54' },
  { iso2: 'AS', nameEn: 'American Samoa', nameEs: 'Samoa Americana', dialCode: '1' },
  { iso2: 'AT', nameEn: 'Austria', nameEs: 'Austria', dialCode: '43' },
  { iso2: 'AU', nameEn: 'Australia', nameEs: 'Australia', dialCode: '61' },
  { iso2: 'AW', nameEn: 'Aruba', nameEs: 'Aruba', dialCode: '297' },
  { iso2: 'AX', nameEn: 'Aland Islands', nameEs: 'Islas Åland', dialCode: '358' },
  { iso2: 'AZ', nameEn: 'Azerbaijan', nameEs: 'Azerbaiyán', dialCode: '994' },
  { iso2: 'BA', nameEn: 'Bosnia and Herzegovina', nameEs: 'Bosnia y Herzegovina', dialCode: '387' },
  { iso2: 'BB', nameEn: 'Barbados', nameEs: 'Barbados', dialCode: '1' },
  { iso2: 'BD', nameEn: 'Bangladesh', nameEs: 'Bangladés', dialCode: '880' },
  { iso2: 'BE', nameEn: 'Belgium', nameEs: 'Bélgica', dialCode: '32' },
  { iso2: 'BF', nameEn: 'Burkina Faso', nameEs: 'Burkina Faso', dialCode: '226' },
  { iso2: 'BG', nameEn: 'Bulgaria', nameEs: 'Bulgaria', dialCode: '359' },
  { iso2: 'BH', nameEn: 'Bahrain', nameEs: 'Baréin', dialCode: '973' },
  { iso2: 'BI', nameEn: 'Burundi', nameEs: 'Burundi', dialCode: '257' },
  { iso2: 'BJ', nameEn: 'Benin', nameEs: 'Benín', dialCode: '229' },
  { iso2: 'BL', nameEn: 'Saint Barthelemy', nameEs: 'San Bartolomé', dialCode: '590' },
  { iso2: 'BM', nameEn: 'Bermuda', nameEs: 'Bermudas', dialCode: '1' },
  { iso2: 'BN', nameEn: 'Brunei', nameEs: 'Brunéi', dialCode: '673' },
  { iso2: 'BO', nameEn: 'Bolivia', nameEs: 'Bolivia', dialCode: '591' },
  { iso2: 'BQ', nameEn: 'Caribbean Netherlands', nameEs: 'Caribe Neerlandés', dialCode: '599' },
  { iso2: 'BR', nameEn: 'Brazil', nameEs: 'Brasil', dialCode: '55' },
  { iso2: 'BS', nameEn: 'Bahamas', nameEs: 'Bahamas', dialCode: '1' },
  { iso2: 'BT', nameEn: 'Bhutan', nameEs: 'Bután', dialCode: '975' },
  { iso2: 'BW', nameEn: 'Botswana', nameEs: 'Botsuana', dialCode: '267' },
  { iso2: 'BY', nameEn: 'Belarus', nameEs: 'Bielorrusia', dialCode: '375' },
  { iso2: 'BZ', nameEn: 'Belize', nameEs: 'Belice', dialCode: '501' },
  { iso2: 'CA', nameEn: 'Canada', nameEs: 'Canadá', dialCode: '1' },
  { iso2: 'CC', nameEn: 'Cocos Islands', nameEs: 'Islas Cocos', dialCode: '61' },
  {
    iso2: 'CD',
    nameEn: 'Democratic Republic of the Congo',
    nameEs: 'República Democrática del Congo',
    dialCode: '243',
  },
  { iso2: 'CF', nameEn: 'Central African Republic', nameEs: 'República Centroafricana', dialCode: '236' },
  { iso2: 'CG', nameEn: 'Congo', nameEs: 'Congo', dialCode: '242' },
  { iso2: 'CH', nameEn: 'Switzerland', nameEs: 'Suiza', dialCode: '41' },
  { iso2: 'CI', nameEn: "Cote d'Ivoire", nameEs: 'Costa de Marfil', dialCode: '225' },
  { iso2: 'CK', nameEn: 'Cook Islands', nameEs: 'Islas Cook', dialCode: '682' },
  { iso2: 'CL', nameEn: 'Chile', nameEs: 'Chile', dialCode: '56' },
  { iso2: 'CM', nameEn: 'Cameroon', nameEs: 'Camerún', dialCode: '237' },
  { iso2: 'CN', nameEn: 'China', nameEs: 'China', dialCode: '86' },
  { iso2: 'CO', nameEn: 'Colombia', nameEs: 'Colombia', dialCode: '57' },
  { iso2: 'CR', nameEn: 'Costa Rica', nameEs: 'Costa Rica', dialCode: '506' },
  { iso2: 'CU', nameEn: 'Cuba', nameEs: 'Cuba', dialCode: '53' },
  { iso2: 'CV', nameEn: 'Cabo Verde', nameEs: 'Cabo Verde', dialCode: '238' },
  { iso2: 'CW', nameEn: 'Curacao', nameEs: 'Curazao', dialCode: '599' },
  { iso2: 'CX', nameEn: 'Christmas Island', nameEs: 'Isla de Navidad', dialCode: '61' },
  { iso2: 'CY', nameEn: 'Cyprus', nameEs: 'Chipre', dialCode: '357' },
  { iso2: 'CZ', nameEn: 'Czechia', nameEs: 'Chequia', dialCode: '420' },
  { iso2: 'DE', nameEn: 'Germany', nameEs: 'Alemania', dialCode: '49' },
  { iso2: 'DJ', nameEn: 'Djibouti', nameEs: 'Yibuti', dialCode: '253' },
  { iso2: 'DK', nameEn: 'Denmark', nameEs: 'Dinamarca', dialCode: '45' },
  { iso2: 'DM', nameEn: 'Dominica', nameEs: 'Dominica', dialCode: '1' },
  { iso2: 'DO', nameEn: 'Dominican Republic', nameEs: 'República Dominicana', dialCode: '1' },
  { iso2: 'DZ', nameEn: 'Algeria', nameEs: 'Argelia', dialCode: '213' },
  { iso2: 'EC', nameEn: 'Ecuador', nameEs: 'Ecuador', dialCode: '593' },
  { iso2: 'EE', nameEn: 'Estonia', nameEs: 'Estonia', dialCode: '372' },
  { iso2: 'EG', nameEn: 'Egypt', nameEs: 'Egipto', dialCode: '20' },
  { iso2: 'EH', nameEn: 'Western Sahara', nameEs: 'Sáhara Occidental', dialCode: '212' },
  { iso2: 'ER', nameEn: 'Eritrea', nameEs: 'Eritrea', dialCode: '291' },
  { iso2: 'ES', nameEn: 'Spain', nameEs: 'España', dialCode: '34' },
  { iso2: 'ET', nameEn: 'Ethiopia', nameEs: 'Etiopía', dialCode: '251' },
  { iso2: 'FI', nameEn: 'Finland', nameEs: 'Finlandia', dialCode: '358' },
  { iso2: 'FJ', nameEn: 'Fiji', nameEs: 'Fiyi', dialCode: '679' },
  { iso2: 'FK', nameEn: 'Falkland Islands', nameEs: 'Islas Malvinas', dialCode: '500' },
  { iso2: 'FM', nameEn: 'Micronesia', nameEs: 'Micronesia', dialCode: '691' },
  { iso2: 'FO', nameEn: 'Faroe Islands', nameEs: 'Islas Feroe', dialCode: '298' },
  { iso2: 'FR', nameEn: 'France', nameEs: 'Francia', dialCode: '33' },
  { iso2: 'GA', nameEn: 'Gabon', nameEs: 'Gabón', dialCode: '241' },
  { iso2: 'GB', nameEn: 'United Kingdom', nameEs: 'Reino Unido', dialCode: '44' },
  { iso2: 'GD', nameEn: 'Grenada', nameEs: 'Granada', dialCode: '1' },
  { iso2: 'GE', nameEn: 'Georgia', nameEs: 'Georgia', dialCode: '995' },
  { iso2: 'GF', nameEn: 'French Guiana', nameEs: 'Guayana Francesa', dialCode: '594' },
  { iso2: 'GG', nameEn: 'Guernsey', nameEs: 'Guernsey', dialCode: '44' },
  { iso2: 'GH', nameEn: 'Ghana', nameEs: 'Ghana', dialCode: '233' },
  { iso2: 'GI', nameEn: 'Gibraltar', nameEs: 'Gibraltar', dialCode: '350' },
  { iso2: 'GL', nameEn: 'Greenland', nameEs: 'Groenlandia', dialCode: '299' },
  { iso2: 'GM', nameEn: 'Gambia', nameEs: 'Gambia', dialCode: '220' },
  { iso2: 'GN', nameEn: 'Guinea', nameEs: 'Guinea', dialCode: '224' },
  { iso2: 'GP', nameEn: 'Guadeloupe', nameEs: 'Guadalupe', dialCode: '590' },
  { iso2: 'GQ', nameEn: 'Equatorial Guinea', nameEs: 'Guinea Ecuatorial', dialCode: '240' },
  { iso2: 'GR', nameEn: 'Greece', nameEs: 'Grecia', dialCode: '30' },
  {
    iso2: 'GS',
    nameEn: 'South Georgia and the South Sandwich Islands',
    nameEs: 'Islas Georgias del Sur y Sandwich del Sur',
    dialCode: '500',
  },
  { iso2: 'GT', nameEn: 'Guatemala', nameEs: 'Guatemala', dialCode: '502' },
  { iso2: 'GU', nameEn: 'Guam', nameEs: 'Guam', dialCode: '1' },
  { iso2: 'GW', nameEn: 'Guinea-Bissau', nameEs: 'Guinea-Bisáu', dialCode: '245' },
  { iso2: 'GY', nameEn: 'Guyana', nameEs: 'Guyana', dialCode: '592' },
  { iso2: 'HK', nameEn: 'Hong Kong', nameEs: 'Hong Kong', dialCode: '852' },
  { iso2: 'HN', nameEn: 'Honduras', nameEs: 'Honduras', dialCode: '504' },
  { iso2: 'HR', nameEn: 'Croatia', nameEs: 'Croacia', dialCode: '385' },
  { iso2: 'HT', nameEn: 'Haiti', nameEs: 'Haití', dialCode: '509' },
  { iso2: 'HU', nameEn: 'Hungary', nameEs: 'Hungría', dialCode: '36' },
  { iso2: 'ID', nameEn: 'Indonesia', nameEs: 'Indonesia', dialCode: '62' },
  { iso2: 'IE', nameEn: 'Ireland', nameEs: 'Irlanda', dialCode: '353' },
  { iso2: 'IL', nameEn: 'Israel', nameEs: 'Israel', dialCode: '972' },
  { iso2: 'IM', nameEn: 'Isle of Man', nameEs: 'Isla de Man', dialCode: '44' },
  { iso2: 'IN', nameEn: 'India', nameEs: 'India', dialCode: '91' },
  {
    iso2: 'IO',
    nameEn: 'British Indian Ocean Territory',
    nameEs: 'Territorio Británico del Océano Índico',
    dialCode: '246',
  },
  { iso2: 'IQ', nameEn: 'Iraq', nameEs: 'Irak', dialCode: '964' },
  { iso2: 'IR', nameEn: 'Iran', nameEs: 'Irán', dialCode: '98' },
  { iso2: 'IS', nameEn: 'Iceland', nameEs: 'Islandia', dialCode: '354' },
  { iso2: 'IT', nameEn: 'Italy', nameEs: 'Italia', dialCode: '39' },
  { iso2: 'JE', nameEn: 'Jersey', nameEs: 'Jersey', dialCode: '44' },
  { iso2: 'JM', nameEn: 'Jamaica', nameEs: 'Jamaica', dialCode: '1' },
  { iso2: 'JO', nameEn: 'Jordan', nameEs: 'Jordania', dialCode: '962' },
  { iso2: 'JP', nameEn: 'Japan', nameEs: 'Japón', dialCode: '81' },
  { iso2: 'KE', nameEn: 'Kenya', nameEs: 'Kenia', dialCode: '254' },
  { iso2: 'KG', nameEn: 'Kyrgyzstan', nameEs: 'Kirguistán', dialCode: '996' },
  { iso2: 'KH', nameEn: 'Cambodia', nameEs: 'Camboya', dialCode: '855' },
  { iso2: 'KI', nameEn: 'Kiribati', nameEs: 'Kiribati', dialCode: '686' },
  { iso2: 'KM', nameEn: 'Comoros', nameEs: 'Comoras', dialCode: '269' },
  { iso2: 'KN', nameEn: 'Saint Kitts and Nevis', nameEs: 'San Cristóbal y Nieves', dialCode: '1' },
  { iso2: 'KP', nameEn: 'North Korea', nameEs: 'Corea del Norte', dialCode: '850' },
  { iso2: 'KR', nameEn: 'South Korea', nameEs: 'Corea del Sur', dialCode: '82' },
  { iso2: 'KW', nameEn: 'Kuwait', nameEs: 'Kuwait', dialCode: '965' },
  { iso2: 'KY', nameEn: 'Cayman Islands', nameEs: 'Islas Caimán', dialCode: '1' },
  { iso2: 'KZ', nameEn: 'Kazakhstan', nameEs: 'Kazajistán', dialCode: '7' },
  { iso2: 'LA', nameEn: 'Laos', nameEs: 'Laos', dialCode: '856' },
  { iso2: 'LB', nameEn: 'Lebanon', nameEs: 'Líbano', dialCode: '961' },
  { iso2: 'LC', nameEn: 'Saint Lucia', nameEs: 'Santa Lucía', dialCode: '1' },
  { iso2: 'LI', nameEn: 'Liechtenstein', nameEs: 'Liechtenstein', dialCode: '423' },
  { iso2: 'LK', nameEn: 'Sri Lanka', nameEs: 'Sri Lanka', dialCode: '94' },
  { iso2: 'LR', nameEn: 'Liberia', nameEs: 'Liberia', dialCode: '231' },
  { iso2: 'LS', nameEn: 'Lesotho', nameEs: 'Lesoto', dialCode: '266' },
  { iso2: 'LT', nameEn: 'Lithuania', nameEs: 'Lituania', dialCode: '370' },
  { iso2: 'LU', nameEn: 'Luxembourg', nameEs: 'Luxemburgo', dialCode: '352' },
  { iso2: 'LV', nameEn: 'Latvia', nameEs: 'Letonia', dialCode: '371' },
  { iso2: 'LY', nameEn: 'Libya', nameEs: 'Libia', dialCode: '218' },
  { iso2: 'MA', nameEn: 'Morocco', nameEs: 'Marruecos', dialCode: '212' },
  { iso2: 'MC', nameEn: 'Monaco', nameEs: 'Mónaco', dialCode: '377' },
  { iso2: 'MD', nameEn: 'Moldova', nameEs: 'Moldavia', dialCode: '373' },
  { iso2: 'ME', nameEn: 'Montenegro', nameEs: 'Montenegro', dialCode: '382' },
  { iso2: 'MF', nameEn: 'Saint Martin', nameEs: 'San Martín', dialCode: '590' },
  { iso2: 'MG', nameEn: 'Madagascar', nameEs: 'Madagascar', dialCode: '261' },
  { iso2: 'MH', nameEn: 'Marshall Islands', nameEs: 'Islas Marshall', dialCode: '692' },
  { iso2: 'MK', nameEn: 'North Macedonia', nameEs: 'Macedonia del Norte', dialCode: '389' },
  { iso2: 'ML', nameEn: 'Mali', nameEs: 'Malí', dialCode: '223' },
  { iso2: 'MM', nameEn: 'Myanmar', nameEs: 'Myanmar', dialCode: '95' },
  { iso2: 'MN', nameEn: 'Mongolia', nameEs: 'Mongolia', dialCode: '976' },
  { iso2: 'MO', nameEn: 'Macao', nameEs: 'Macao', dialCode: '853' },
  { iso2: 'MP', nameEn: 'Northern Mariana Islands', nameEs: 'Islas Marianas del Norte', dialCode: '1' },
  { iso2: 'MQ', nameEn: 'Martinique', nameEs: 'Martinica', dialCode: '596' },
  { iso2: 'MR', nameEn: 'Mauritania', nameEs: 'Mauritania', dialCode: '222' },
  { iso2: 'MS', nameEn: 'Montserrat', nameEs: 'Montserrat', dialCode: '1' },
  { iso2: 'MT', nameEn: 'Malta', nameEs: 'Malta', dialCode: '356' },
  { iso2: 'MU', nameEn: 'Mauritius', nameEs: 'Mauricio', dialCode: '230' },
  { iso2: 'MV', nameEn: 'Maldives', nameEs: 'Maldivas', dialCode: '960' },
  { iso2: 'MW', nameEn: 'Malawi', nameEs: 'Malaui', dialCode: '265' },
  { iso2: 'MX', nameEn: 'Mexico', nameEs: 'México', dialCode: '52' },
  { iso2: 'MY', nameEn: 'Malaysia', nameEs: 'Malasia', dialCode: '60' },
  { iso2: 'MZ', nameEn: 'Mozambique', nameEs: 'Mozambique', dialCode: '258' },
  { iso2: 'NA', nameEn: 'Namibia', nameEs: 'Namibia', dialCode: '264' },
  { iso2: 'NC', nameEn: 'New Caledonia', nameEs: 'Nueva Caledonia', dialCode: '687' },
  { iso2: 'NE', nameEn: 'Niger', nameEs: 'Níger', dialCode: '227' },
  { iso2: 'NF', nameEn: 'Norfolk Island', nameEs: 'Isla Norfolk', dialCode: '672' },
  { iso2: 'NG', nameEn: 'Nigeria', nameEs: 'Nigeria', dialCode: '234' },
  { iso2: 'NI', nameEn: 'Nicaragua', nameEs: 'Nicaragua', dialCode: '505' },
  { iso2: 'NL', nameEn: 'Netherlands', nameEs: 'Países Bajos', dialCode: '31' },
  { iso2: 'NO', nameEn: 'Norway', nameEs: 'Noruega', dialCode: '47' },
  { iso2: 'NP', nameEn: 'Nepal', nameEs: 'Nepal', dialCode: '977' },
  { iso2: 'NR', nameEn: 'Nauru', nameEs: 'Nauru', dialCode: '674' },
  { iso2: 'NU', nameEn: 'Niue', nameEs: 'Niue', dialCode: '683' },
  { iso2: 'NZ', nameEn: 'New Zealand', nameEs: 'Nueva Zelanda', dialCode: '64' },
  { iso2: 'OM', nameEn: 'Oman', nameEs: 'Omán', dialCode: '968' },
  { iso2: 'PA', nameEn: 'Panama', nameEs: 'Panamá', dialCode: '507' },
  { iso2: 'PE', nameEn: 'Peru', nameEs: 'Perú', dialCode: '51' },
  { iso2: 'PF', nameEn: 'French Polynesia', nameEs: 'Polinesia Francesa', dialCode: '689' },
  { iso2: 'PG', nameEn: 'Papua New Guinea', nameEs: 'Papúa Nueva Guinea', dialCode: '675' },
  { iso2: 'PH', nameEn: 'Philippines', nameEs: 'Filipinas', dialCode: '63' },
  { iso2: 'PK', nameEn: 'Pakistan', nameEs: 'Pakistán', dialCode: '92' },
  { iso2: 'PL', nameEn: 'Poland', nameEs: 'Polonia', dialCode: '48' },
  { iso2: 'PM', nameEn: 'Saint Pierre and Miquelon', nameEs: 'San Pedro y Miquelón', dialCode: '508' },
  { iso2: 'PN', nameEn: 'Pitcairn Islands', nameEs: 'Islas Pitcairn', dialCode: '64' },
  { iso2: 'PR', nameEn: 'Puerto Rico', nameEs: 'Puerto Rico', dialCode: '1' },
  { iso2: 'PS', nameEn: 'Palestine', nameEs: 'Palestina', dialCode: '970' },
  { iso2: 'PT', nameEn: 'Portugal', nameEs: 'Portugal', dialCode: '351' },
  { iso2: 'PW', nameEn: 'Palau', nameEs: 'Palaos', dialCode: '680' },
  { iso2: 'PY', nameEn: 'Paraguay', nameEs: 'Paraguay', dialCode: '595' },
  { iso2: 'QA', nameEn: 'Qatar', nameEs: 'Catar', dialCode: '974' },
  { iso2: 'RE', nameEn: 'Reunion', nameEs: 'Reunión', dialCode: '262' },
  { iso2: 'RO', nameEn: 'Romania', nameEs: 'Rumanía', dialCode: '40' },
  { iso2: 'RS', nameEn: 'Serbia', nameEs: 'Serbia', dialCode: '381' },
  { iso2: 'RU', nameEn: 'Russia', nameEs: 'Rusia', dialCode: '7' },
  { iso2: 'RW', nameEn: 'Rwanda', nameEs: 'Ruanda', dialCode: '250' },
  { iso2: 'SA', nameEn: 'Saudi Arabia', nameEs: 'Arabia Saudita', dialCode: '966' },
  { iso2: 'SB', nameEn: 'Solomon Islands', nameEs: 'Islas Salomón', dialCode: '677' },
  { iso2: 'SC', nameEn: 'Seychelles', nameEs: 'Seychelles', dialCode: '248' },
  { iso2: 'SD', nameEn: 'Sudan', nameEs: 'Sudán', dialCode: '249' },
  { iso2: 'SE', nameEn: 'Sweden', nameEs: 'Suecia', dialCode: '46' },
  { iso2: 'SG', nameEn: 'Singapore', nameEs: 'Singapur', dialCode: '65' },
  { iso2: 'SH', nameEn: 'Saint Helena', nameEs: 'Santa Elena', dialCode: '290' },
  { iso2: 'SI', nameEn: 'Slovenia', nameEs: 'Eslovenia', dialCode: '386' },
  { iso2: 'SJ', nameEn: 'Svalbard and Jan Mayen', nameEs: 'Svalbard y Jan Mayen', dialCode: '47' },
  { iso2: 'SK', nameEn: 'Slovakia', nameEs: 'Eslovaquia', dialCode: '421' },
  { iso2: 'SL', nameEn: 'Sierra Leone', nameEs: 'Sierra Leona', dialCode: '232' },
  { iso2: 'SM', nameEn: 'San Marino', nameEs: 'San Marino', dialCode: '378' },
  { iso2: 'SN', nameEn: 'Senegal', nameEs: 'Senegal', dialCode: '221' },
  { iso2: 'SO', nameEn: 'Somalia', nameEs: 'Somalia', dialCode: '252' },
  { iso2: 'SR', nameEn: 'Suriname', nameEs: 'Surinam', dialCode: '597' },
  { iso2: 'SS', nameEn: 'South Sudan', nameEs: 'Sudán del Sur', dialCode: '211' },
  { iso2: 'ST', nameEn: 'Sao Tome and Principe', nameEs: 'Santo Tomé y Príncipe', dialCode: '239' },
  { iso2: 'SV', nameEn: 'El Salvador', nameEs: 'El Salvador', dialCode: '503' },
  { iso2: 'SX', nameEn: 'Sint Maarten', nameEs: 'Sint Maarten', dialCode: '1' },
  { iso2: 'SY', nameEn: 'Syria', nameEs: 'Siria', dialCode: '963' },
  { iso2: 'SZ', nameEn: 'Eswatini', nameEs: 'Esuatini', dialCode: '268' },
  { iso2: 'TC', nameEn: 'Turks and Caicos Islands', nameEs: 'Islas Turcas y Caicos', dialCode: '1' },
  { iso2: 'TD', nameEn: 'Chad', nameEs: 'Chad', dialCode: '235' },
  { iso2: 'TG', nameEn: 'Togo', nameEs: 'Togo', dialCode: '228' },
  { iso2: 'TH', nameEn: 'Thailand', nameEs: 'Tailandia', dialCode: '66' },
  { iso2: 'TJ', nameEn: 'Tajikistan', nameEs: 'Tayikistán', dialCode: '992' },
  { iso2: 'TK', nameEn: 'Tokelau', nameEs: 'Tokelau', dialCode: '690' },
  { iso2: 'TL', nameEn: 'Timor-Leste', nameEs: 'Timor Oriental', dialCode: '670' },
  { iso2: 'TM', nameEn: 'Turkmenistan', nameEs: 'Turkmenistán', dialCode: '993' },
  { iso2: 'TN', nameEn: 'Tunisia', nameEs: 'Túnez', dialCode: '216' },
  { iso2: 'TO', nameEn: 'Tonga', nameEs: 'Tonga', dialCode: '676' },
  { iso2: 'TR', nameEn: 'Turkey', nameEs: 'Turquía', dialCode: '90' },
  { iso2: 'TT', nameEn: 'Trinidad and Tobago', nameEs: 'Trinidad y Tobago', dialCode: '1' },
  { iso2: 'TV', nameEn: 'Tuvalu', nameEs: 'Tuvalu', dialCode: '688' },
  { iso2: 'TW', nameEn: 'Taiwan', nameEs: 'Taiwán', dialCode: '886' },
  { iso2: 'TZ', nameEn: 'Tanzania', nameEs: 'Tanzania', dialCode: '255' },
  { iso2: 'UA', nameEn: 'Ukraine', nameEs: 'Ucrania', dialCode: '380' },
  { iso2: 'UG', nameEn: 'Uganda', nameEs: 'Uganda', dialCode: '256' },
  {
    iso2: 'UM',
    nameEn: 'United States Minor Outlying Islands',
    nameEs: 'Islas Ultramarinas de Estados Unidos',
    dialCode: '1',
  },
  { iso2: 'US', nameEn: 'United States', nameEs: 'Estados Unidos', dialCode: '1' },
  { iso2: 'UY', nameEn: 'Uruguay', nameEs: 'Uruguay', dialCode: '598' },
  { iso2: 'UZ', nameEn: 'Uzbekistan', nameEs: 'Uzbekistán', dialCode: '998' },
  { iso2: 'VA', nameEn: 'Vatican City', nameEs: 'Ciudad del Vaticano', dialCode: '39' },
  { iso2: 'VC', nameEn: 'Saint Vincent and the Grenadines', nameEs: 'San Vicente y las Granadinas', dialCode: '1' },
  { iso2: 'VE', nameEn: 'Venezuela', nameEs: 'Venezuela', dialCode: '58' },
  { iso2: 'VG', nameEn: 'British Virgin Islands', nameEs: 'Islas Vírgenes Británicas', dialCode: '1' },
  { iso2: 'VI', nameEn: 'U.S. Virgin Islands', nameEs: 'Islas Vírgenes de los Estados Unidos', dialCode: '1' },
  { iso2: 'VN', nameEn: 'Vietnam', nameEs: 'Vietnam', dialCode: '84' },
  { iso2: 'VU', nameEn: 'Vanuatu', nameEs: 'Vanuatu', dialCode: '678' },
  { iso2: 'WF', nameEn: 'Wallis and Futuna', nameEs: 'Wallis y Futuna', dialCode: '681' },
  { iso2: 'WS', nameEn: 'Samoa', nameEs: 'Samoa', dialCode: '685' },
  { iso2: 'XK', nameEn: 'Kosovo', nameEs: 'Kosovo', dialCode: '383' },
  { iso2: 'YE', nameEn: 'Yemen', nameEs: 'Yemen', dialCode: '967' },
  { iso2: 'YT', nameEn: 'Mayotte', nameEs: 'Mayotte', dialCode: '262' },
  { iso2: 'ZA', nameEn: 'South Africa', nameEs: 'Sudáfrica', dialCode: '27' },
  { iso2: 'ZM', nameEn: 'Zambia', nameEs: 'Zambia', dialCode: '260' },
  { iso2: 'ZW', nameEn: 'Zimbabwe', nameEs: 'Zimbabue', dialCode: '263' },
];
